'use strict';

angular.module('TurneroApp').component('coRecepcionDniAnunciar', {
    bindings: {
        centroAtencionSeleccionado: '<'
    },
    controller: [
        'turnosService', '$rootScope', 'utilsService', '$scope',
    function (turnosService, $rootScope, utilsService, $scope) {
        var ctrl = this;
        ctrl.Titulo = "Anunciar un turno"
        ctrl.buscarPersona = function () {
            ctrl.Persona = null;
            ctrl.PersonaLista = null;
            utilsService.swalTitle('Buscando ciudadano', 'info');
            turnosService.Get_Persona_Con_Turno_Recepcion({ 'Id_Centro_Atencion': ctrl.centroAtencionSeleccionado.id, 'Nro_Documento': ctrl.CUIL_DNI }).$promise.then(function (resultado) {

                if (resultado.Data.length == 1) {
                    ctrl.Persona = resultado.Data[0];
                    $rootScope.$broadcast('MostrarTurnosAnunciar', ctrl.Persona);
                } else if (resultado.Data.length > 1) {
                    ctrl.PersonasLista = resultado.Data
                } else {
                    $rootScope.$broadcast('MostrarTurnosAnunciar', null);
                }
                swal.close();


            }).catch(function (error) {
                utilsService.errores(error);
            });
        };

        ctrl.seleccionarPersona = function (persona) {
            ctrl.personaSeleccionada = persona;
            $rootScope.$broadcast('MostrarTurnosAnunciar', ctrl.personaSeleccionada);

        };

        ctrl.setValor = function (value) {
            $rootScope.$broadcast('resetTimer', true);
            if (ctrl.CUIL_DNI != null && ctrl.CUIL_DNI.toString().length < 12) {
                ctrl.CUIL_DNI = Number(ctrl.CUIL_DNI ? ctrl.CUIL_DNI.toString() + value.toString() : value.toString());
            } else if (ctrl.CUIL_DNI == null) {
                ctrl.CUIL_DNI = Number(value.toString());
            }
        }

        ctrl.backspace = function () {
            $rootScope.$broadcast('resetTimer', true);
            if (ctrl.CUIL_DNI != null && ctrl.CUIL_DNI.toString().length > 0) {
                ctrl.CUIL_DNI = Number(ctrl.CUIL_DNI.toString().slice(0, -1));
                if (ctrl.CUIL_DNI == 0) {
                    ctrl.CUIL_DNI = null;
                }
            }
        }

        ctrl.goHome = function () {
            ctrl.CUIL_DNI = null;
            $rootScope.$broadcast('GoHome', true);

        }

        $scope.$on('limpiarRecepcion', function (event, bool) {
            ctrl.CUIL_DNI = null;
            ctrl.Persona = null;
            ctrl.PersonaLista = null;
        });

        document.getElementById("cmbSexo").style.display = "none"
    }
    ],
    template: require('./recepcion_DNI.html')
});



// WEBPACK FOOTER //
// ./app/components/recepcion/recepcion_DNIAnunciarComponent.js